if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const quickViewModal = document.getElementById('product-modal');
            
            if (quickViewModal) {
              quickViewModal.classList.remove('active');
              document.body.classList.remove('quickview-open');
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    this.handleUpsellSequentialAdd(
                      response,
                      formData.get("id"),
                      formData
                    );

                    // Trigger cart upsell check after product is added via quick modal
                    setTimeout(() => {
                      if (window.cartCheckboxUpsellInstance) {
                        window.cartCheckboxUpsellInstance.updateCheckboxState();
                      }
                    }, 200);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              this.handleUpsellSequentialAdd(
                response,
                formData.get("id"),
                formData
              );

              // Trigger cart upsell check after product is added
              setTimeout(() => {
                if (window.cartCheckboxUpsellInstance) {
                  window.cartCheckboxUpsellInstance.updateCheckboxState();
                }
              }, 200);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleUpsellSequentialAdd(mainAddResponse, mainVariantId, formData) {
        try {
          if (!this.cart) return;
          const container = this.closest('product-info') || document;
          const upsellCheckboxes = container.querySelectorAll('.product-upsell-toggle .product-upsell-toggle__checkbox[data-upsell-checkbox="true"]');
          if (!upsellCheckboxes.length) return;

          const items = [];
          const mainQuantity = formData ? parseInt(formData.get('quantity')) || 1 : 1;
          upsellCheckboxes.forEach(cb => {
            if (cb.checked) { // removed upsellAdded gating
              const variantId = cb.getAttribute('data-variant-id');
              const mainProductId = cb.getAttribute('data-main-product-id');
              const upsellProductHandle = cb.getAttribute('data-upsell-product-handle');
              if (variantId) {
                items.push({
                  id: Number(variantId),
                  quantity: mainQuantity,
                  properties: { 
                    _upsell_of: mainVariantId,
                    _bound_to_product: mainProductId,
                    _upsell_product_handle: upsellProductHandle,
                    _is_hidden_upsell: "true"
                  }
                });
              }
            }
          });

          if (!items.length) return;

          const sections = this.cart.getSectionsToRender().map((s) => s.id || s.section);
          const payload = { items };
          if (sections && sections.length) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          })
            .then(r => r.json())
            .then(upsellResponse => {
              if (upsellResponse && upsellResponse.sections) {
                this.cart.renderContents(upsellResponse);
              } else {
                this.refreshCartSections();
              }
            })
            .catch(err => {
              console.warn('Upsell add failed', err);
            });
        } catch (e) {
          console.error('Upsell sequence error', e);
        }
      }

      refreshCartSections() {
        // Minimal refresh: trigger a cart update fetch via existing cartUpdate event
        fetch(`${routes.cart_url}.js`)
          .then(r => r.json())
          .then(() => {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-sequential' });
          })
          .catch(e => console.error('Cart refresh failed', e));
      }
    }
  );
}

